import type { PortfolioReport } from '@interfaces/portfolioReport';
import type { BulkRebalanceReportDetailSelection } from '../../detail/reportModal/reportDetailModal';
import { getReportClientLabel, getReportGoalLabel } from './reportLabels';

export const resolveDetailSelectionReport = (
  selection: BulkRebalanceReportDetailSelection,
  reportsById: Map<string, PortfolioReport>,
): BulkRebalanceReportDetailSelection => {
  const report =
    selection.report ?? reportsById.get(selection.reportId) ?? undefined;

  if (!report || report === selection.report) {
    return selection;
  }

  const clientLabel = getReportClientLabel(report);
  const goalLabel = getReportGoalLabel(report);

  return {
    ...selection,
    report,
    clientLabel: clientLabel || selection.clientLabel,
    goalLabel: goalLabel || selection.goalLabel,
  };
};

export const isDetailSelectionReportPending = (
  selection: BulkRebalanceReportDetailSelection | null,
  reportsById: Map<string, PortfolioReport>,
  reportsResolving: boolean,
): boolean =>
  Boolean(
    selection &&
      !selection.report &&
      !reportsById.has(selection.reportId) &&
      reportsResolving,
  );
